export default "__VITE_ASSET__mCYacFM2__"